import React, { useState, useEffect } from "react";
import Location from './location'
import Duration from './duration'
import HourlyRate from './hourly-rate'
import Overtime from './overtime'
import ShiftSchedule from './shift-schedule'




const Calculate = ({ getContractDetails }) => {


    useEffect(() => {

        document.title = 'Roam Pays: Calculate your tax';

    }, []);


    return (


        <div className="card" >

            <div className="card-title" >

                <div className="box-title color-white fs-18 fs-helvetica" >

                    Contract Details

                </div>



            </div>

            <div className="card-content" >


                <div className="input-container" >
                    <label >Location</label>

                    <Location getContractDetails={getContractDetails} />


                </div>



                <div className="input-container" >
                    <label >Duration</label>

                    <Duration getContractDetails={getContractDetails} />



                </div>

                <div className="fd-row g-12 align-self-stretch" >
                    <div className="input-container" >
                        <label >Hourly Rate</label>

                        <HourlyRate getContractDetails={getContractDetails} />




                    </div>

                    <div className="input-container" >
                        <label >Overtime</label>

                        <Overtime getContractDetails={getContractDetails} />


                    </div>
                </div>

                <div className="input-container" >
                    <label >Shift Schedule</label>

                    <ShiftSchedule getContractDetails={getContractDetails} />


                </div>



            </div>





        </div>






    );
};

export default Calculate;